"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _breadcrumbContext = require("./breadcrumb-context");

/* eslint-disable import/no-extraneous-dependencies */
var useBreadcrumb = function useBreadcrumb(_ref) {
  var location = _ref.location,
      crumbLabel = _ref.crumbLabel,
      crumbSeparator = _ref.crumbSeparator;

  var _React$useContext = _react.default.useContext(_breadcrumbContext.BreadcrumbContext),
      crumbs = _React$useContext.crumbs,
      updateCrumbs = _React$useContext.updateCrumbs;

  _react.default.useEffect(function () {
    updateCrumbs({
      location: location,
      crumbLabel: crumbLabel,
      crumbSeparator: crumbSeparator
    });
  }, [location, crumbLabel, crumbSeparator, updateCrumbs]);

  return {
    crumbs: crumbs
  };
};

var _default = useBreadcrumb;
exports.default = _default;